/**
 * 관리자 인증 헬퍼
 *
 * 왜 필요한가:
 *   기존에는 role/storeId/storeCode 를 localStorage 에서 직접 읽었다.
 *   localStorage 는 사용자가 콘솔에서 임의로 바꿀 수 있다 (예: adminRole='master').
 *   백엔드는 JWT 만 신뢰하므로 데이터 노출은 막히지만, 프론트의 메뉴/카메라 같은
 *   '클라이언트 측 게이트' 가 풀리는 위화감이 생긴다.
 *
 * 해결:
 *   JWT payload 에서 role/storeId/storeCode 를 꺼내 쓴다.
 *   JWT 는 서버 비밀키로 서명돼 있어 사용자가 위조해도 백엔드에서 거절된다.
 *   서명 검증은 백엔드 책임이고, 프론트는 "서버가 발급한 그대로의 값" 만 본다.
 *
 *   토큰이 없거나 만료되면 모든 getter 가 null 을 돌려준다 → 메뉴/페이지가
 *   기본값(권한 없음)으로 닫힌다.
 */

/**
 * JWT payload 디코드.
 * - 서명은 검증하지 않는다 (그건 백엔드 몫).
 * - 토큰이 깨졌거나 base64 해독에 실패하면 null.
 */
function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    // JWT 는 URL-safe base64 — '-' → '+', '_' → '/' 로 정규화
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    // padding 보정
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const json = atob(padded);
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    try {
      // 일부 환경에서 escape 가 비표준이라 빠진 경우 폴백
      const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
      return JSON.parse(atob(padded));
    } catch {
      return null;
    }
  }
}

function getPayload() {
  const token = localStorage.getItem('token');
  return decodeJwtPayload(token);
}

/** 관리자 role ('master' | 'manager') 또는 null */
export function getAdminRole() {
  const p = getPayload();
  return p?.role ?? null;
}

/** 관리자 storeId (manager 만 갖는다) 또는 null */
export function getAdminStoreId() {
  const p = getPayload();
  return p?.storeId ?? null;
}

/** 관리자 storeCode (지점 코드, manager 만 갖는다) 또는 null */
export function getAdminStoreCode() {
  const p = getPayload();
  return p?.storeCode ?? null;
}

/** master 여부 */
export function isMaster() {
  return getAdminRole() === 'master';
}

/** manager 여부 */
export function isManager() {
  return getAdminRole() === 'manager';
}
